<ion-app>
  <div class="loading-container">
    <img class="logo-spinner" src="assets/images/logo.jpg" />
  </div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
